import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientNoteQKeys } from "@hooks/queries/patientNote/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientNote } from "@customTypes/patientNote";


interface MutationProps {
  patientNote: Partial<PatientNote>;
  patientId: string;
}

export const useUpdatePatientNote = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ patientNote, patientId }: MutationProps) => {
      return api.patch(`notes/${patientNote.id}`, {
        ...patientNote,
        type: patientNote.category,
      });
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "update-patient-note-success",
      });

      queryClient.invalidateQueries(
        patientNoteQKeys.allWithFilters({ patientId: variables.patientId })
      );
    },

    onError: (res: any) => {
      console.error("[From Update Patient Note]", res);

      handleErrors(res, "mutation");
    },
  });
};
